import { Chain } from "viem";
import { INetwork } from "../networks";

export enum ChainSymbols {
  eth = "eth",
  uni = "uni",
  base = "base",
  bsc = "bsc",
  tbsc = "tbsc",
  sol = "sol",
  solDevnet = "tsol",
  sui = "sui",
  suiDevnet = "tsui",
  ton = "ton",
  tonDevnet = "tton",
}

export enum ChainIds {
  eth = 1,
  uni = 130,
  base = 8453,
  bsc = 56,
  tbsc = 97,
  sol = 8453,
  solDevnet = 84532,
  sui = 84532,
  suiDevnet = 100,
  ton = 10,
  tonDevnet = 11,
}

export interface IBlockExplorer {
  name: string;
  url: string;
  hash: string;
  address: string;
}

export interface IChain extends Chain {
  id: number;
  name: string;
  symbol: ChainSymbols;
  network: INetwork;
  logo: string;
  nativeCurrency: {
    name: string;
    symbol: string;
    decimals: number;
  };
  blockExplorers: {
    default: IBlockExplorer;
    [key: string]: IBlockExplorer;
  };
}
